var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass: "no-style",
      attrs: { to: "/special-services/" + _vm.experience.id }
    },
    [
      _c(
        "div",
        { staticClass: "mb-4" },
        [
          _c("div", { staticClass: "cover-experience-photo-sm bg-dark mb-3" }, [
            _c("img", {
              directives: [
                {
                  name: "lazy",
                  rawName: "v-lazy",
                  value: _vm.getCoverImage(_vm.experience.experience_photos),
                  expression: "getCoverImage(experience.experience_photos)"
                }
              ],
              staticClass: "img-experience-photo",
              attrs: { alt: _vm.experience.title }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex justify-content-start align-items-center" },
            [
              _c("div", { staticClass: "flex-fill experience-category" }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$options.filters.serviceParentName(
                        _vm.experience.service_id,
                        _vm.globalState.services
                      )
                    )
                  }
                }),
                _vm._v(
                  "\n        •\n        " +
                    _vm._s(
                      _vm._f("multiLangName")(
                        _vm.globalState.cities[_vm.experience.province_id]
                      )
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              Number(_vm.experience.num_rating) > 0
                ? _c(
                    "div",
                    { staticClass: "flex-fill text-right text-small" },
                    [
                      _c("i", { staticClass: "fas fa-star -rating-star mr-0" }),
                      _vm._v(
                        " " +
                          _vm._s(Number(_vm.experience.avg_rating).toFixed(1)) +
                          "\n        (" +
                          _vm._s(_vm.experience.num_rating) +
                          ")\n      "
                      )
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "experience-item-title pt-1" }, [
            _c("span", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$options.filters.shortText(_vm.experience.title, 80)
                )
              }
            })
          ]),
          _vm._v(" "),
          _vm.displayCost
            ? [
                _vm.experience.cost
                  ? _c("div", { staticClass: "pt-2 experience-item-price" }, [
                      _c("h3", { staticClass: "d-inline-block text-info" }, [
                        _vm._v(_vm._s(_vm._f("currency")(_vm.experience.cost)))
                      ]),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("message.experience.starting_at")) +
                          "\n        "
                      ),
                      _vm.experience.duration > 0
                        ? _c("span", [
                            _vm._v(
                              "\n          •\n          " +
                                _vm._s(_vm.experience.duration) +
                                "\n          " +
                                _vm._s(
                                  _vm.$tc(
                                    "message.hour",
                                    _vm.experience.duration
                                  )
                                ) +
                                "\n        "
                            )
                          ])
                        : _vm._e()
                    ])
                  : _c("div", { staticClass: "pt-2" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "border border-info px-2 text-info text-small rounded-pill"
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.$t("message.experience.evaluate"))
                            )
                          ])
                        ]
                      )
                    ])
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-027df822", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-027df822","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/experience/Experience.vue
// module id = 1967
// module chunks = 0